angular.module("AccountingBoxApp")
    .directive("keepScrollPos", function ($state, $window, $timeout, $location, $anchorScroll) {

        // cache scroll position of each route's templateUrl
        var scrollPosCache = {};
        var queryCache={};
   // console.log('keeep scrool pos directive');
        // compile function
        return function (scope, element, attrs) {

            scope.$on('$stateChangeStart', function () {
                // store scroll position for the current view
               // console.log('prescrollpos:',element.scrollTop);
              // console.log('$location.path',$location.path());
              // console.log('$location.search',$location.search());
              //  console.log('appineer scrop pos is:',element.scrollTop());
                if ($state.current) {
                    scrollPosCache[$location.path()] =element.scrollTop();//element.scrollTop;
                    queryCache[$location.path()]=$location.search();
                }
            });

            scope.$on('$stateChangeSuccess', function () {
                if(queryCache[$location.path()]) {
                    $location.search(queryCache[$location.path()]);
                }
              // console.log('$location.hash',$location.hash());
              // console.log('$location.search',$location.search());
              // console.log('scrollPosCache[$location.path()]:',scrollPosCache[$location.path()]);

              // if hash is specified explicitly, it trumps previously stored scroll position
                if ($location.hash()) {
                    $anchorScroll();

                    // else get previous scroll position; if none, scroll to the top of the page
                } else {
                    var prevScrollPos = scrollPosCache[$location.path()] || 0;
                    $timeout(function () {
                      //  element.scrollTop=prevScrollPos;
                        element.scrollTop(prevScrollPos);
                        //document.getElementById('appInnerContainer').scrollTop = prevScrollPos;                       // $window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
                    }, 1);
                }
            });
        }
    });
